// extracted by mini-css-extract-plugin
export var activeFilterButton = "_or-c";
export var backButton = "_or-4";
export var backIcon = "_or-5";
export var chevronShortcut = "_or-6";
export var container = "_or-1";
export var editor = "_or-8";
export var editorWrapper = "_or-7";
export var prefix = "_or-2";
export var searchIcon = "_or-3";
export var suffix = "_or-9";
export var suffixContent = "_or-a";
export var suffixText = "_or-b";
export var wrapper = "_or-0";